import { Action } from 'redux';
import { delay } from 'redux-saga';
import { put, select, takeEvery } from 'redux-saga/effects';
import { RootState } from 'types/store';
import { getType } from 'typesafe-actions';
import * as actions from './actions';

function* handleChangeFaq(action: Action & { payload: number }) {
  const state: RootState = yield select();
  const currentIndex = state.faq.index;
  if (action.payload !== currentIndex) {
    yield put(actions.setOpacity(false));
    yield delay(250);
    yield put(actions.setOpacity(true));
    yield put(actions.changeFAQ(action.payload));
  }
}

function* watchChangeFAQRequests() {
  yield takeEvery(getType(actions.requestChangeFAQ), handleChangeFaq);
}

export default function*() {
  yield watchChangeFAQRequests();
}



// WEBPACK FOOTER //
// ./src/store/modules/faq/saga.ts